import { render, staticRenderFns } from "./FormPresentation.vue?vue&type=template&id=b0e23896"
import script from "./FormPresentation.vue?vue&type=script&lang=js"
export * from "./FormPresentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports